import { render } from "./elem-upload.vue?vue&type=template&id=f4fe60fe&ts=true"
import script from "./elem-upload.vue?vue&type=script&lang=ts"
export * from "./elem-upload.vue?vue&type=script&lang=ts"

import "./elem-upload.vue?vue&type=style&index=0&id=f4fe60fe&lang=less"

import exportComponent from "/usr/local/share/applications/yushifu-shop-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__